import { apiClient } from './apiClient';
import { 
  RecurringExpense, 
  CreateRecurringExpenseRequest, 
  UpdateRecurringExpenseRequest 
} from './types';

export const recurringExpenseService = {
  async getAll(): Promise<RecurringExpense[]> {
    return apiClient.get<RecurringExpense[]>('/recurring-expenses');
  },

  async getById(id: string): Promise<RecurringExpense> {
    return apiClient.get<RecurringExpense>(`/recurring-expenses/${id}`);
  },

  async create(expense: CreateRecurringExpenseRequest): Promise<RecurringExpense> {
    return apiClient.post<CreateRecurringExpenseRequest, RecurringExpense>('/recurring-expenses', expense);
  },

  async update(id: string, expense: UpdateRecurringExpenseRequest): Promise<RecurringExpense> {
    return apiClient.put<UpdateRecurringExpenseRequest, RecurringExpense>(`/recurring-expenses/${id}`, expense);
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/recurring-expenses/${id}`);
  },

  async toggleActive(id: string): Promise<RecurringExpense> {
    return apiClient.post<{}, RecurringExpense>(`/recurring-expenses/${id}/toggle-active`, {});
  },

  /**
   * Створює витрату з шаблону. date (ISO з локальним зсувом) дозволяє датувати платіж
   * конкретним місяцем, за замовчуванням — поточний момент
   */
  async createReceipt(id: string, date?: string): Promise<any> {
    const query = date ? `?date=${encodeURIComponent(date)}` : '';
    return apiClient.post<{}, any>(`/recurring-expenses/${id}/create-receipt${query}`, {});
  },

  async getUpcoming(days: number = 7): Promise<RecurringExpense[]> {
    return apiClient.get<RecurringExpense[]>(`/recurring-expenses/upcoming?days=${days}`);
  }
};
